import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  requestLogin,
  requestEmpLogin,
  userLogout,
  requestRecentlyJob,
} from "../Redux/actions";
import "./DarkMode.css";
import jwt_decode from "jwt-decode";
import infobytes_logo from "../images/infobytes_trans.png";

function Header(props) {

  const navigate = useNavigate();
  const [user, setUSer] = useState({});
  const [emp, setEmp] = useState({});

  useEffect(() => {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 401) {
          props.userLogout();
        }
        return error;
      }
    );
  }, []);

  function logout() {
    props.userLogout();
    navigate("/home");
  }

  useEffect(() => {
    let loginData = props.candidate.loginData;
    if (loginData !== undefined) {
      if (loginData?.data?.status === "success") {
        setUSer(loginData.data.data);
      } else {
        setUSer({});
      }
    } else {
      setUSer({});
    }
  }, [props.candidate.loginData]);

  useEffect(() => {
    let empLoginData = props.employee.empLoginData;
    if (empLoginData !== undefined) {
      if (empLoginData?.data?.status === "success") {
        setEmp(empLoginData.data.data);
      } else {
        setEmp({});
      }
    } else {
      setEmp({});
    }
  }, [props.employee.empLoginData]);

  function gotToTop() {
    window.scrollTo(0, 0);
  }

  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (localStorage.getItem("dark") === "true") {
      document.body.classList.add("dark");
      return true;
    } else {
      return false;
    }
  });

  const setDarkMode = (e) => {
    localStorage.setItem("dark", !isDarkMode);
    setIsDarkMode(!isDarkMode);
    document.body.classList.toggle("dark");
  };

  return (
    <>
      <header>
        <nav className="navbar navbar-expand-lg header-light bg-transparent disable-fixed" data-header-hover="light">
          <div className="container-fluid">
            <div className="col-auto me-auto">
              <a className="navbar-brand" href="demo-application.html">
                <img src="front/images/demo-application-logo-white.png"
                  data-at2x="front/images/demo-application-logo-white@2x.png" alt="" className="default-logo" />
                <img src="front/images/demo-application-logo-black.png"
                  data-at2x="front/images/demo-application-logo-black@2x.png" alt="" className="alt-logo" />
                <img src="front/images/demo-application-logo-black.png"
                  data-at2x="front/images/demo-application-logo-black@2x.png" alt="" className="mobile-logo" />
              </a>
            </div>
            <div className="col-auto menu-order position-static">
              <button className="navbar-toggler float-start" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarNav" aria-controls="navbarNav" aria-label="Toggle navigation">
                <span className="navbar-toggler-line"></span>
                <span className="navbar-toggler-line"></span>
                <span className="navbar-toggler-line"></span>
                <span className="navbar-toggler-line"></span>
              </button>
            </div>
            <div className="col-auto col-auto xs-ps-0">
              <div className="header-icon">
                <div className="header-button">
                  <a href="/login"
                    className="btn btn-small btn-rounded with-rounded btn-box-shadow btn-dark-gray text-uppercase-inherit">Login
                    <span className="bg-licorice-blue text-white"><i
                      className="feather icon-feather-arrow-right"></i></span></a>
                </div>
              </div>
            </div>
          </div>
        </nav>
        {/* <!-- end navigation--> */}
      </header>
    </>
  );
}
const mapStateToProps = (state) => {
  return { candidate: state.candidate, employee: state.employee };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { requestLogin, requestEmpLogin, userLogout, requestRecentlyJob },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Header);
